import { Api } from '@axiom/ui';
import type { BarredLocation } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class BarredLocationsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.clientApiBase,
    });
  }

  readBarredLocations() {
    return super.read<{ data: BarredLocation[] }>({
      endpoint: `/barredLocations`,
      method: 'GET',
    });
  }
}
export const BarredLocationsLegacyApi = new BarredLocationsApiClass();
